import { Period } from "../model/Period";
import { ProductType } from "motty-utils";
import { isDefined } from "./isDefined";
export const enumValues = (enumerable) => {
    const keysAndValues = Object.values(enumerable);
    const values = [];
    keysAndValues.forEach((keyOrValue) => {
        if (isNaN(Number(keyOrValue))) {
            const value = isDefined(enumerable[keyOrValue]) ? enumerable[keyOrValue] : keyOrValue;
            values.push(value);
        }
    });
    return values;
};
export const isEnumValue = (enumerable, value) => {
    return enumValues(enumerable).includes(value);
};
export const isPeriod = (value) => isEnumValue(Period, value);
export const isProduct = (value) => isEnumValue(ProductType, value);
